/*
 *in this module there are all the functions to create
 *  - plot the marker
 *  - manipulate the marker
 */
/**
 * import modules
 */
 import VectorLayer from 'ol/layer/Vector'
 import {Icon, Style} from 'ol/style'
 import Draw from 'ol/interaction/Draw'
 import VectorSource from 'ol/source/Vector'
 import pccomments from '../parkmap/pccomments'
 import functions from '../common/functions'
 /**
  * set the marker ID to 0
  */

 let MarkId = 0
 let schemeId = 0
 let schemeName = ''

 /**
  * marker source
  */
 const Msource = new VectorSource()

 /**
  * set the dummy parameter iDelRef to 0
  * it's used to refresh the source of the pmlayers and display the new marker
  */

 const initVector = (mapView, overlay) => {
   /**
    * marker variable for the symbols
    */

   const myColors = ['rgba(255,255,255,0.1)']
   const mySource = ['/img/symbols/marker1.png']
   /**
    * add the correct symbols and prevent duplicates
    */

   let iterator = 0

   const styleFn = (symbol) => {
     let retSytle

     /**
      * get the current style if is already setup
      */

     if (typeof (symbol.get('styledwithcolor')) !== 'undefined') {
       retSytle = new Style({
         image: new Icon({
           // opacity: 0.95,
           src: symbol.get('mysource'),
           color: symbol.get('styledwithcolor'),
           anchor: [14, 40],
           anchorXUnits: 'pixels',
           anchorYUnits: 'pixels'
         })
       })
     }
     /**
      * else set the new style
      */
     else {
       symbol.set('styledwithcolor', myColors[iterator])
       symbol.set('mysource', mySource[iterator])

       retSytle = new Style({
         image: new Icon({
           src: mySource[0],
           color: myColors[0],
           anchor: [14, 40],
           anchorXUnits: 'pixels',
           anchorYUnits: 'pixels'
         })
       })
       /**
        * removing the last symbols prevent to add duplicates
        */
     }
     return [retSytle]
   }

   /**
    * marker layer
    */

   const markLayer = new VectorLayer({
     source: Msource,
     style: styleFn
   })

   /**
    * add the markLayer layer to the map
    */

   mapView.addLayer(markLayer)

   /**
    * comment form cancel handler
    */
   $('#consultCancel').on('click', function (e) {
     if ($('#ccoords').val() !== 'N/A') {
       removeMarker()
     }
   })



   /**
    * marker tool handler
    */

   $('.consultissue').on('click', function (e) {
     /**
      * prevent default behaviour
      * add the mark interaction to the map
      * hide the popup
      */
     e.preventDefault()
     MarkId = 0 // currently only allow one issue at a time, this allows for more in the future
     schemeId = $(this).attr('data-schemeid')
     schemeName = $(this).attr('data-schemename')


     addMark('Point')

     overlay.setPosition(undefined)

     /**
      * hide the empty comment error
      */

     $('.emptyComm').css('display', 'none')

     /**
      * check if it's a mobile device
      * hide the tool menu if it's open
      * hide the main bar if it's open
      */

     if (functions.mobileTabletView()) {
       if ($('#dropdownToolsMobile em').hasClass('fa-caret-down')) {
          $('#dropdownToolsMobile').trigger('click')
       }
       if ($('#mainNav').hasClass('show')) {
         $('#mainNav').removeClass('show')
       }
     }
   })

   /**
    * these var are for the creation of the marker
    * they are global so we can remove it later
    */

   let mark
   let counter = true
   /**
    * add the marker
    */

   const addMark = (Type) => {
     /**
      * set counter to true
      * we use it to prevent error when we remove a marker
      */
     counter = true
     /**
      * set the mark interaction
      */

     mark = new Draw({
       source: Msource,
       type: Type
     })

     /**
      * this occurs when you finish to draw the marker
      */

     mark.on('drawend', (event) => {
       counter = true
       let theCoords = event.feature.getGeometry().getCoordinates().toString()
       pccomments.consultInit(schemeId,schemeName,theCoords, MarkId,'N/A','N/A',0, '2')
     })

     /**
      * this occurs after you finish to draw the marker
      */

     markLayer.on('change', () => {
       if (counter === true) {
         /**
          * we set immediately the counter to false and stop to run this function after it finish
          * apply the correct id to the last plotted marker
          */

         counter = false
         let ind = Msource.getFeatures().length - 1
         Msource.getFeatures()[ind].setId(MarkId)
         /**
          * set feature id for feature
          */
         MarkId += 1
       }
       mapView.removeInteraction(mark)
     })
     /**
      * add the mark interaction to the map
      */
     mapView.addInteraction(mark)

     /**
      * end function addMark (Type)
      */
   }

   /**
    * end initVector
    */
 }

 // Removes marker from marker layer
 const removeMarker = () => {
   let ind = Msource.getFeatures().length - 1
   if (ind !== -1) {
    Msource.removeFeature(Msource.getFeatures()[ind])
   }
 }
 /**
  * EXPORT
  */

 export default {
   initVector,
   removeMarker
 }
